<template>
  <div>
      <vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series"></vue-apex-charts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        VueApexCharts,
    },
    mounted() {
        this.getData()
    },
    data() {
        return {
            series: [
            ],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'bar'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '40%'
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                }
            },
        }
    },
    methods: {
        async getData() {
            return await this.$http.get('/product/admin-dashboard')
            .then(res => {
                let data = res.data.data
                let series = []
                let legendNames = []
                data.forEach(element => {
                    series.push({
                        name: element.cfu_name,
                        data: [
                            {
                                x: element.cfu_name,
                                y: element.total
                            }
                        ]
                    })
                    legendNames.push(element.cfu_name)
                });
                this.series = series
            })
        }
    }
}
</script>

<style>

</style>